/*
 * IRIS custom: "Load more" infinite-scroll-style pagination for collection
 * grids (all collections), replacing Dawn's classic page-number pagination
 * per merchant request. Fetches the NEXT page's full HTML (paginate.next.url
 * already carries any active filter/sort query string, so this respects
 * whatever the shopper has filtered/sorted by), pulls the product grid
 * (#product-grid) and the next <load-more-products> block out of it, and
 * appends the new products to the current grid in place — no page reload.
 * If the fetched page has no further <load-more-products> content (i.e. it
 * was the last page), this element simply empties itself, removing the
 * button.
 */
(function () {
  if (window.customElements && window.customElements.get('load-more-products')) return;

  class LoadMoreProducts extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('[data-load-more-button]');
      this.loading = false;
      if (this.button) {
        this._onClick = this.onClick.bind(this);
        this.button.addEventListener('click', this._onClick);
      }
    }

    onClick(event) {
      event.preventDefault();
      if (this.loading || !this.button) return;
      this.loading = true;
      this.button.classList.add('is-loading');

      const url = this.button.getAttribute('href');
      const grid = document.getElementById('product-grid');

      fetch(url)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const newGrid = html.getElementById('product-grid');

          if (grid && newGrid) {
            Array.from(newGrid.children).forEach((child) => {
              grid.appendChild(child);
            });
          }

          const newLoadMore = html.querySelector('load-more-products');
          if (newLoadMore) {
            this.innerHTML = newLoadMore.innerHTML;
            this.button = this.querySelector('[data-load-more-button]');
            if (this.button) {
              this._onClick = this.onClick.bind(this);
              this.button.addEventListener('click', this._onClick);
            }
          } else {
            this.innerHTML = '';
            this.button = null;
          }
        })
        .catch(() => {
          if (this.button) this.button.classList.remove('is-loading');
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }

  customElements.define('load-more-products', LoadMoreProducts);
})();
